(() => {
  if (window.__cloudimageDeferredLoader) return;
  window.__cloudimageDeferredLoader = true;

  const config = document.querySelector("script[data-cloudimage-src]");
  const targets = document.querySelectorAll(".cloudimage-360");
  if (!config || !targets.length) return;

  let loading;
  let initializing = false;
  const load = () => {
    if (window.CI360) {
      window.CI360.init?.();
      return Promise.resolve();
    }
    if (!loading) {
      loading = new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = config.dataset.cloudimageSrc;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
    return loading;
  };

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        if (!initializing && entries.some((entry) => entry.isIntersecting)) {
          initializing = true;
          load()
            .then(() => observer.disconnect())
            .catch((error) => {
              initializing = false;
              console.error("Cloudimage 360 failed to initialize", error);
            });
        }
      },
      { rootMargin: "300px 0px" }
    );
    targets.forEach((target) => observer.observe(target));
  } else {
    load();
  }
})();
